import { useState, useEffect } from 'react';

type scrollDirection = 'down' | 'up';

export const useScrollDirection = (threshold = 0): scrollDirection => {
    const [scrollDirection, setScrollDirection] = useState<scrollDirection>('down');

    useEffect(() => {
        let ticking = false;
        let lastScroll = window.scrollY;

        const updateScrollDirection = () => {
            const scroll = window.scrollY;

            if (Math.abs(scroll - lastScroll) < threshold) {
                ticking = false;
                return;
            }
            setScrollDirection(scroll > lastScroll ? 'down' : 'up');
            lastScroll = scroll > 0 ? scrollY : 0;
            ticking = false;
        };

        const onScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(updateScrollDirection);
                ticking = true;
            }
        };

        window.addEventListener('scroll', onScroll);

        return () => window.removeEventListener('scroll', onScroll);
    }, [scrollDirection, threshold]);

    return scrollDirection;
};
